'use client';

import Link from 'next/link';

import { CaseStudyCTA } from '@/app/(pages)/(services)/components/CaseStudyCTA';
import { AdaptiveLogo } from '@/components/adaptive-logo';

import type { AllTurtlesInActionProps } from './AllTurtlesInAction';
import type { PortfolioShowcaseItem } from './PortfolioShowcase';
import type { ServicePageHeroProps } from './ServicePageHero';
import type { UniquePoint } from './WhatMakesUsUnique';
import type { WhatWeDoProps } from './WhatWeDo';

import { AllTurtlesInAction } from './AllTurtlesInAction';
import { PortfolioShowcase } from './PortfolioShowcase';
import { ServiceLayout } from './ServiceLayout';
import { ServicePageHero } from './ServicePageHero';
import { TeamProofText } from './TeamProofText';
import { WhatMakesUsUnique } from './WhatMakesUsUnique';
import { WhatWeDo } from './WhatWeDo';

export interface ServiceModulesContent {
  allTurtlesInAction: AllTurtlesInActionProps;
  caseStudyLink?: string;
  caseStudyText?: string;
  hero: ServicePageHeroProps;
  layout: {
    nextLink: string;
    hoverTextColor: string;
    logoColor?: string;
  };
  portfolioShowcase?: PortfolioShowcaseItem[];
  teamProof: { text: string };
  whatMakesUsUnique: { points: UniquePoint[] };
  whatWeDo: WhatWeDoProps;
}

export interface ServiceModulesProps {
  content: ServiceModulesContent;
}

export function ServiceModules({ content }: ServiceModulesProps) {
  const {
    hero,
    layout,
    teamProof,
    whatWeDo,
    whatMakesUsUnique,
    allTurtlesInAction,
    portfolioShowcase,
    caseStudyLink,
    caseStudyText,
  } = content;

  return (
    <ServiceLayout>
      <div className="relative z-30">
        <Link href="/" className="block pl-5 pt-2 tablet:mb-4" aria-label="Go to All Turtles Home">
          <AdaptiveLogo block blendMode={false} color={layout.logoColor ?? 'text-at'} aria-hidden />
        </Link>
      </div>
      <ServicePageHero {...hero} />
      <div className="relative z-20">
        <div className="bg-navy">
          <TeamProofText text={teamProof.text} />
          <WhatWeDo {...whatWeDo} />
          <WhatMakesUsUnique {...whatMakesUsUnique} />
        </div>
      </div>
      <AllTurtlesInAction {...allTurtlesInAction} />
      {caseStudyLink && caseStudyText && <CaseStudyCTA ctaLink={caseStudyLink} ctaText={caseStudyText} />}
      {portfolioShowcase && portfolioShowcase.length > 0 && <PortfolioShowcase items={portfolioShowcase} />}
    </ServiceLayout>
  );
}
